const en_US = {
    site_title: "SuperMap iManager For Kubernetes Help",
    site_productName: "SuperMap iManager For Kubernetes ",
    home_productName: "SuperMap iManager For Kubernetes ",
    home_productDescrp: "The GIS solution based on Cloud Native Technology",
    home_gettingStarted: "Get Started",
    home_tutorial: "Take the Tutorial",
    header_home: "Home",
    header_guides: "Guides",
    header_microservices: "GIS Cloud Suite",
    header_docs: "Docs",
    header_topics: "Tech Docs",
    header_terms: "GIS Terms",
    header_api: "APIs",
    header_specs: "Specs",
    header_tutorial: "Tutorial",
    header_blog: "Blog",
    header_community: "Community",
    footer_guides: "Guides",
    footer_docs: "Docs",
    footer_topics: "Tech Docs",
    footer_tutorial:"Tutorial",
    footer_microservices:"GIS Cloud Suite",
    footer_api: "APIs",
    rightcontents_title:"On This Page",
    //... ...
}
export default en_US;